export default __webpack_public_path__ + "25b3d86d4f238e486c7a2380c9f8d11e.png";